import { CSSProperties } from 'react';
import { Box, ButtonProps } from '@material-ui/core';
import { WbButton } from '../WbButton';

interface Props {
  clear?: ButtonProps;
  selectAll?: ButtonProps;
  containerStyle?: CSSProperties;
  extraActions?: { label: string; action: () => void }[];
}

export const EnumButtons = ({
  clear,
  selectAll,
  containerStyle,
  extraActions,
}: Props) => {
  return (
    <Box
      style={{
        display: 'flex',
        gap: '16px',
        padding: '8px 16px 0px 16px',
        ...containerStyle,
      }}
    >
      {selectAll && (
        <WbButton variant="text" label="Select All" {...selectAll} />
      )}
      {clear && <WbButton variant="text" label="Clear" {...clear} />}
      {extraActions &&
        extraActions.map(a => (
          <WbButton
            variant="text"
            key={a.label}
            label={a.label}
            onClick={a.action}
          />
        ))}
    </Box>
  );
};
